import { API_URL, GETAPI, POSTAPI } from "./config";

// countryCode without "+" (91 / 1 / 971); the API adds the "+". Callers without it stay on India.
export const GEBYMOBILENO = async (mobile, countryCode = "91") => {
  let query = "&mobile=" + `${countryCode}${mobile}`;
  const data = await GETAPI(API_URL.getByMobile, query);
  return data;
};

export const CREATEUSER = async (data) => {
   const formData = new FormData();

   if(data.firstName){
    formData.append("first_name",data.firstName);
   }

   if(data.lastName){
    formData.append("last_name",data.lastName);
   }

   if(data.mobile){
    formData.append("mobile","+"+(data.countryCode ?? "91")+data.mobile);
   }

   if(data.middleName){
    formData.append("middle_name",data.middleName);
   }

   if(data.email){
    formData.append("email",data.email);
   }

   if(data.gender){
    formData.append("gender",data.gender);
   }

    const res = await POSTAPI(API_URL.addByAdmin, formData);
    return res;
  };


